/* import __COLOCATED_TEMPLATE__ from './topic.hbs'; */
import Component from "@glimmer/component";
import { service } from "@ember/service";
import TEMPLATE from "./topic.hbs";
import { setComponentTemplate } from "@ember/component";
export default class Results extends Component {
  static #_ = (() => dt7948.g(this.prototype, "siteSettings", [service]))();
  #siteSettings = (() => (dt7948.i(this, "siteSettings"), void 0))();
}
setComponentTemplate(TEMPLATE, Results);